import { render, staticRenderFns } from "./pdm_product.vue?vue&type=template&id=4bc576c2"
import script from "./pdm_product.vue?vue&type=script&lang=js"
export * from "./pdm_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports